import { createWebHistory, createRouter } from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Signup from '@/views/Signup.vue'
import Scan from '@/views/Scan.vue'
import Profile from '@/views/Profile.vue'
import Pricing from '@/views/Pricing.vue'
import About from '@/views/About.vue'
import HowItWorks from '@/views/HowItWorks.vue'



const history = createWebHistory();
const router = createRouter({
    history,
        routes: [
        {
            path: '/',
            name: "home",
            component: Home
        },
        {
            path: '/login',
            name: 'login',
            meta: { layout: "internal"},
            component: Login
        },
        {
            path: '/signup',
            name: 'signup',
            meta: { layout: "internal"},
            component: Signup
        },
        {
            path: '/scan',
            name: 'scan',
            meta: { layout: "internal"},
            component: Scan
        },
        {
            path: '/profile',
            name: 'profile',
            meta: { layout: "internal"},
            component: Profile
        },
        {
            path: '/pricing',
            name: 'pricing',
            component: Pricing
        },
        {
            path: '/about',
            name: 'about',
            component: About
        },
        {
            path: '/how-it-works',
            name: 'how-it-works',
            component: HowItWorks
        },
    ]
})

export default router